import React from 'react';

const Hero3DGraphic = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{`
        .iso-container {
          position: relative;
          width: 300px;
          height: 300px;
          transform-style: preserve-3d;
          transform: rotateX(60deg) rotateZ(-45deg);
          animation: float 6s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: rotateX(60deg) rotateZ(-45deg) translateZ(0px); }
          50% { transform: rotateX(60deg) rotateZ(-45deg) translateZ(20px); }
        }

        .iso-platform {
          position: absolute;
          width: 240px;
          height: 240px;
          top: 30px;
          left: 30px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 
            -15px 15px 30px rgba(0, 0, 0, 0.05),
            inset 0 0 0 1px rgba(255, 255, 255, 0.5);
          transform-style: preserve-3d;
        }

        .iso-platform::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 30px;
          background: #e2e8f0;
          bottom: -30px;
          left: 0;
          transform-origin: top;
          transform: rotateX(-90deg);
          border-radius: 0 0 12px 12px;
        }

        .iso-platform::after {
          content: '';
          position: absolute;
          width: 30px;
          height: 100%;
          background: #f1f5f9;
          top: 0;
          right: -30px;
          transform-origin: left;
          transform: rotateY(90deg);
          border-radius: 0 12px 12px 0;
        }

        .iso-core {
          position: absolute;
          width: 80px;
          height: 80px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) translateZ(40px);
          transform-style: preserve-3d;
        }

        .iso-cube-face {
          position: absolute;
          width: 80px;
          height: 80px;
          background: rgba(59, 130, 246, 0.15);
          border: 1px solid rgba(59, 130, 246, 0.3);
          backdrop-filter: blur(4px);
        }

        .iso-cube-front  { transform: translateZ(40px); }
        .iso-cube-back   { transform: rotateY(180deg) translateZ(40px); }
        .iso-cube-right  { transform: rotateY(90deg) translateZ(40px); }
        .iso-cube-left   { transform: rotateY(-90deg) translateZ(40px); }
        .iso-cube-top    { transform: rotateX(90deg) translateZ(40px); }
        .iso-cube-bottom { transform: rotateX(-90deg) translateZ(40px); background: rgba(59, 130, 246, 0.3); filter: blur(10px); }

        .iso-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotateX(-90deg) rotateY(0deg) rotateZ(45deg) translateZ(40px);
          font-family: var(--font-display);
          font-size: 64px;
          font-weight: 800;
          color: var(--primary);
          text-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          transform-style: preserve-3d;
          animation: textHover 4s ease-in-out infinite;
        }

        @keyframes textHover {
          0%, 100% { transform: translate(-50%, -50%) rotateX(-90deg) rotateY(45deg) rotateZ(0deg) translateZ(20px); }
          50% { transform: translate(-50%, -50%) rotateX(-90deg) rotateY(45deg) rotateZ(0deg) translateZ(30px); }
        }

        .iso-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          border: 2px solid rgba(0, 216, 255, 0.4);
          border-radius: 50%;
          transform-style: preserve-3d;
          box-shadow: 0 0 15px rgba(0, 216, 255, 0.2);
        }

        .ring-1 {
          width: 220px;
          height: 220px;
          margin-top: -110px;
          margin-left: -110px;
          animation: spinZ 10s linear infinite;
        }

        .ring-2 {
          width: 260px;
          height: 260px;
          margin-top: -130px;
          margin-left: -130px;
          border-color: rgba(59, 130, 246, 0.3);
          animation: spinZReverse 14s linear infinite;
        }

        @keyframes spinZ {
          from { transform: translateZ(40px) rotateZ(0deg); }
          to { transform: translateZ(40px) rotateZ(360deg); }
        }

        @keyframes spinZReverse {
          from { transform: translateZ(20px) rotateZ(360deg); }
          to { transform: translateZ(20px) rotateZ(0deg); }
        }

        .particle {
          position: absolute;
          width: 8px;
          height: 8px;
          background: var(--secondary);
          border-radius: 50%;
          box-shadow: 0 0 10px var(--secondary);
          transform: translateZ(60px);
        }

        .p1 { top: 20%; left: 20%; animation: particleFloat 4s infinite alternate; }
        .p2 { top: 70%; left: 80%; animation: particleFloat 5s infinite alternate-reverse; }
        .p3 { top: 80%; left: 30%; animation: particleFloat 6s infinite alternate; }

        @keyframes particleFloat {
          0% { transform: translateZ(60px) translateY(0); }
          100% { transform: translateZ(90px) translateY(-20px); }
        }
      `}</style>

      <div className="iso-container au asc">
        <div className="iso-platform">
          <div className="iso-ring ring-1"></div>
          <div className="iso-ring ring-2"></div>
          
          <div className="particle p1"></div>
          <div className="particle p2"></div>
          <div className="particle p3"></div>

          <div className="iso-core">
            <div className="iso-cube-face iso-cube-front"></div>
            <div className="iso-cube-face iso-cube-back"></div>
            <div className="iso-cube-face iso-cube-right"></div>
            <div className="iso-cube-face iso-cube-left"></div>
            <div className="iso-cube-face iso-cube-top"></div>
            <div className="iso-cube-face iso-cube-bottom"></div>
          </div>
        </div>
        <div className="iso-text">AI</div>
      </div>
    </div>
  );
};

export default Hero3DGraphic;
